function createSupports() {
    const canvasElement = document.createElement('canvas')

    return {
        beaconAPI: typeof navigator?.sendBeacon === 'function',
        webP: canvasElement.toDataURL('image/webp').indexOf('data:image/webp') === 0
    }
}

export const supports = createSupports()